import React, { useRef, useEffect } from 'react';
//import LoadingOverlay from 'react-loading-overlay'
import { useHistory } from 'react-router-dom'
import { Button, ListGroupItem } from 'reactstrap'
import { useSelector } from 'react-redux'
import SchoolService from 'services/school'

import Link from '../Link'
import { ContentSteeringController } from 'hls.js'

const FileListItem = (props) => {
	const roles = useSelector((state) => state.auth.roles)
	let history = useHistory()

	let button = null
	let icon = null

	const greyOut = (props.onlyShowAssignmentId != null && props.onlyShowAssignmentId !== props.id) || props.lessonNoAccess
	const showButton = !greyOut && !props.lessonNoAccess
	//const showButton = true

	const isDirectLink = (props.onlyShowAssignmentId != null && props.onlyShowAssignmentId === props.id) || props.lessonAccess
	const blockForStudent = (roles.includes('student') && props.isExamination && !isDirectLink)


	const itemRef = useRef(null)
	const scrollIntoView = props.onlyShowAssignmentId === props.id
	useEffect(() => {
		if (scrollIntoView && itemRef.current) {
			console.log('Scrolling to item')
			itemRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
		}
	}, [scrollIntoView])

	const onClickPdf = async (props) => {
		if (props.url) {
			// For the admin view
			const newTab = window.open(props.url, "_blank")
			newTab.focus()
		}
		else {
			// For course content view
			props.showPdf()
		}
	}

	const onOpenFormLink = async (props) => {
		props.showFormLink()
	}

	if (props.type) {
		if (props.type === 'video') {
			//icon = <i className="pe-7s-film text-muted fsize-2" />
			icon = <i className={`pe-7s-film fsize-2 ${greyOut ? '' : 'text-muted'}`} />
			button = showButton ? (
				<Button onClick={() => props.playVideo()}
					className="mb-2 mr-2 btn-icon btn-pill" size="sm" outline color="primary">
					<i className="pe-7s-play btn-icon-wrapper"> </i>
					Spela
				</Button>
			) : null
		} else if (props.type === 'pdf') {
			//icon = <i className="pe-7s-file text-muted fsize-2" />
			icon = <i className={`pe-7s-file fsize-2 ${greyOut ? '' : 'text-muted'}`} />
			button = showButton ? (
				<Button
					onClick={() => onClickPdf(props)}
					className="mb-2 mr-2 btn-icon btn-pill" size="sm" outline color="primary">
					<i className="pe-7s-download btn-icon-wrapper"> </i>
					Hämta
				</Button>
			) : null
		} else if (props.type === 'formlink') {
			//icon = <i className="pe-7s-note2 text-muted fsize-2" />
			icon = <i className={`pe-7s-note2 fsize-2 ${greyOut ? '' : 'text-muted'}`} />
			{/*<a href={props.formlink} target='_blank' rel="noopener noreferrer">*/ }
			button = props.formlink && showButton ? (
				<Button
					onClick={() => onOpenFormLink(props)}
					className="mb-2 mr-2 btn-icon btn-pill" size="sm" outline color="primary">
					<i className="pe-7s-link btn-icon-wrapper"> </i>
					Öppna
				</Button>
			) : null
		}

		if (props.teacherPage) {
			button = (
				<Button
					onClick={() => getCourseContentPath(props.lessonID)}
					size="lg"
					className="btn-shadow-primary"
					color="primary"
				>
					Visa
				</Button>
			);
		}
	}
	const getCourseContentPath = async (id) => {
		try {
			const res = await SchoolService.getCourseContentPath(id);
			history.push(res.path);
		} catch (e) { }
	}



	return (
		<React.Fragment >
			{/*<LoadingOverlay
				tag="div"
				active={props.shouldDelete}
				styles={{
					overlay: (base) => ({
						...base,
						background: 'red',
						opacity: 0.5
					})
				}}>*/}
			<ListGroupItem>
				{/*<div className="widget-content p-0">*/}
				<div className={`widget-content p-0 ${greyOut ? 'la-greyedOutListItem' : ''}`}
					ref={itemRef}>

					<div className="widget-content-wrapper">
						<div className="widget-content-left center-elem mr-2">{icon}</div>
						<div className="widget-content-left" >
							{/*<div className="widget-heading">*/}
							<div className={`widget-heading ${greyOut ? 'la-greyedOutListItem' : ''}`}>
								{props.title}
							</div>
							{props.description ? props.description : null}
						</div>
						<div className="widget-content-right center-elem">
							{!blockForStudent && button}
							{props.type === 'video' &&
								!roles.includes('student') &&
								(roles.includes('admin') || roles.includes('user') || roles.includes('customer'))
								&& <Link id={props.id} linkType={'video'} />}

							{props.type === 'formlink' &&
								!roles.includes('student') &&
								(roles.includes('admin') || roles.includes('user') || roles.includes('customer'))
								&& <Link id={props.id} linkType={'formlink'} />}

							{props.type === 'pdf' &&
								!roles.includes('student') &&
								(roles.includes('admin') || roles.includes('user') || roles.includes('customer'))
								&& <Link id={props.id} linkType={'pdf'} />}


						</div>
					</div>
				</div>
			</ListGroupItem>
			{/*</LoadingOverlay>*/}
		</React.Fragment>
	);
};

export default FileListItem;
